// extracted by mini-css-extract-plugin
export default {"colorPickerContainer":"styles2_colorPickerContainer__8OE6p","colorPreview":"styles2_colorPreview__cM+0E","sliderPicker":"styles2_sliderPicker__pCB7O"};